// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1dFhA","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3XFRu"};